import {
  PATCH_TACHOGRAPH_INFRINGEMENT_ARCHIVED,
  PATCH_TACHOGRAPH_INFRINGEMENT_CLOSED,
} from '@/modules/tachograph-infringements/mutations'
import {
  PATCH_WORK_INFRINGEMENT_ARCHIVED,
  PATCH_WORK_INFRINGEMENT_CLOSED,
} from '@/modules/work-infringements/mutations'
import { useOnErrorAuto } from '@/utils/hooks'
import { useMutation } from '@apollo/client'

export type FollowUpSource = 'WORKING_TIME' | 'TACHOGRAPH_USE'

/** Close/reopen and archive/restore for the working time and tachograph use
 * infringements, from their detail pages and from the infringement list. */
export function useFollowUpStateMutations() {
  const onErrorAuto = useOnErrorAuto()
  const options = {
    awaitRefetchQueries: true,
    refetchQueries: 'active' as const,
    onError: onErrorAuto(),
  }
  const [closeTachograph, closingTachograph] = useMutation(
    PATCH_TACHOGRAPH_INFRINGEMENT_CLOSED,
    options
  )
  const [archiveTachograph, archivingTachograph] = useMutation(
    PATCH_TACHOGRAPH_INFRINGEMENT_ARCHIVED,
    options
  )
  const [closeWork, closingWork] = useMutation(
    PATCH_WORK_INFRINGEMENT_CLOSED,
    options
  )
  const [archiveWork, archivingWork] = useMutation(
    PATCH_WORK_INFRINGEMENT_ARCHIVED,
    options
  )

  return {
    loading:
      closingTachograph.loading ||
      archivingTachograph.loading ||
      closingWork.loading ||
      archivingWork.loading,
    setClosed(source: FollowUpSource, id: string, closed: boolean) {
      const variables = { id, closed }
      return source === 'TACHOGRAPH_USE'
        ? closeTachograph({ variables })
        : closeWork({ variables })
    },
    setArchived(
      source: FollowUpSource,
      id: string,
      archived: boolean,
      archivedBasis?: string
    ) {
      const variables = { id, archived, archivedBasis }
      return source === 'TACHOGRAPH_USE'
        ? archiveTachograph({ variables })
        : archiveWork({ variables })
    },
  }
}
